import type { DateTime } from "luxon";

export function calculateFirstPossibleStartDate(
  previousRowStartDate: DateTime | null | undefined
) {
  return previousRowStartDate?.plus({ days: 1 });
}
